<script>
import {formatCompact, formatNumber} from "@/shared/utils/formatters";

export default  {
  name: 'dashboardTotal',
  props: {
    totalOrganizations: {type:Number,default:0},
    fomat: {type:Boolean,default:true},
  },
  methods: {
    formatCompact, formatNumber
  }
}
</script>

<template>
  <div class="total">{{$t('label_dashboard_total')}}: <div class="total-number"> {{fomat? formatCompact(totalOrganizations) : formatNumber(totalOrganizations)}}</div></div>
</template>

<style scoped lang="scss">
.total{
  display: flex;
  justify-content: center;
  gap: 5px;
  font-size: 20px;
  color:#171717;
  font-family: Montserrat, sans-serif;
  .total-number{
    color:#2F60A6;
    font-weight: bold;
  }
}
</style>
